import BasicValidation from 'components/components/common/BasicValidation';
import mergeErrors from 'components/helpers/mergeErrors';
import TransHelper from 'components/common/translations/TransHelper';

export default class ContactFormValidation extends BasicValidation {
  constructor(params, locale = "en") {
    super();
    this.params = params;
    this.locale = locale;
  }

  t = (key) => {
    return TransHelper.translate(this.locale, key);
  }

  emailIsValid() {
    return this.checkIsEmail(this.params.email);
  }

  nameIsValid() {
    return !this.checkLengthIsTooShort(this.params.name, 1);
  }

  messageIsValid() {
    return !this.checkLengthIsTooShort(this.params.message, 1);
  }

  getFormErrors() {
    var hash = {};
    if (!this.emailIsValid()) {
      hash['email'] = this.t('content.errors.contact.email');
    }
    if (!this.nameIsValid()) {
      hash['name'] = this.t('content.errors.contact.name');
    }
    if (!this.messageIsValid()) {
      hash['message'] = this.t('content.errors.contact.message');
    }
    return mergeErrors(hash);
  }

  isValid() {
    return this.emailIsValid() && this.nameIsValid() && this.messageIsValid();
  }
}
